/** @format */

import React, { useEffect } from "react";
import useStorage from "../hooks/useStorage";
import { useAuth } from "../context/AuthContext";

const ProgressBar = () => {
  const { profilePic, setProfilePic } = useAuth();
  const { url, progress } = useStorage(profilePic);

  //RESET FILE TO NULL
  useEffect(() => {
    if (url) {
      setProfilePic(null);
    }
  }, [url, setProfilePic]);

  return (
    <div
      style={{
        width: "100%",
        height: "4px",
        backgroundColor: "#aaa",
        borderRadius: ".25rem",
      }}
    >
      <div
        style={{ width: `${progress}%`, background: "orange", height: "100%" }}
      ></div>
    </div>
  );
};

export default ProgressBar;
